// Base URL of the ErpBase API.
//
// Set REACT_APP_API_BASE_URL in .env (development) and .env.production (build).
// The localhost fallback exists so a fresh checkout runs without configuration;
// it is not a deployment target.
const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || "https://primenewsexpapi.aapkesaath.org";

const apiConfig = {
  baseURL: API_BASE_URL,
  isDevelopment: process.env.NODE_ENV === "development",
  isProduction: process.env.NODE_ENV === "production",
};

export { API_BASE_URL };
export default apiConfig;
